import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import {auth, logInWithEmailAndPassword, signInWithEmailAndPassword, signInWithGoogle} from "../../tools/firebase";
import { useAuthState } from "react-firebase-hooks/auth";
import "./Login.css";
import {Button, Image, Layout} from "antd";
import { Typography } from 'antd';
import { EyeInvisibleOutlined, EyeTwoTone, KeyOutlined, MailOutlined, LoadingOutlined } from '@ant-design/icons';
import { Input } from 'antd';
import { Space, Spin } from 'antd';
import {track} from "@amplitude/analytics-browser";
import logo from "../Resources/logo.png";

const antIcon = (
    <LoadingOutlined
        style={{
            fontSize: 24,
        }}
        spin
    />
);

const { Title, Text } = Typography;
const { Header } = Layout;

function Login() {
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [user, loading, error] = useAuthState(auth);
    const navigate = useNavigate();

    useEffect(() => {
        track("signin_shown");
    }, [])

    useEffect(() => {
        if (loading) {
            // maybe trigger a loading screen
            return;
        }
        if (user) navigate("/dashboard");
    }, [user, loading]);

    if (loading) {
        return (
            <div
                style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    height: '100vh',
                }}
            >
                <Spin indicator={antIcon} />
            </div>
        )
    }

    return (
        <div style={{fontFamily: "Avenir"}}>
            <Header className="header">
                <div className="flex flex-row items-center self-center h-16 gap-4">
                    <Image src={logo} preview={false} style={{width: "2rem", height: "2rem"}}/>
                    <Title
                        level={3}
                        style={{color: "white", marginBottom: 0}}
                        onClick={() => { navigate("/") }}
                    >
                        Dimensions
                    </Title>
                </div>
            </Header>

            <div className="login">
                <div className="login__container">
                    <Image preview={false} src={logo} style={{width: 96, height: 96, marginLeft: "auto", marginRight: "auto"}}/>
                    <Title>Dimensions</Title>
                    <Text style={{marginBottom: 16, fontSize: 16}}>
                        Don't have an account? <Link to="/register">Register</Link> now.
                    </Text>
                    <Input
                        placeholder="E-mail Address"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        prefix={<MailOutlined />}
                        style={{marginBottom: 16}}
                    />
                    <Input.Password
                        placeholder="Password"
                        iconRender={visible => (visible ? <EyeTwoTone /> : <EyeInvisibleOutlined />)}
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                        prefix={<KeyOutlined />}
                        style={{marginBottom: 16}}
                    />
                    <div className="flex flex-row items-center gap-4">
                        <Button
                            onClick={() => logInWithEmailAndPassword(email, password)}
                            type="primary"
                            shape="round"
                        >
                            Sign In
                        </Button>
                        <div>or</div>
                        <Button
                            onClick={signInWithGoogle}
                            type="primary"
                            shape="round"
                        >
                            Sign In with Google
                        </Button>
                    </div>

                    <Button
                        onClick={() => navigate("../reset")}
                        type="link"
                        style={{marginTop: 8}}
                    >
                        Forgot password
                    </Button>

                </div>
            </div>
        </div>
    );
}

export default Login;
